import { laborManagementApi } from '../laborManagementApi';
import { BudgetSummaryView } from '../types/laborManagementTypes';
import { BudgetSummaryQuery } from '../requests/laborManagementRequests';

const budgetSummaryEndpointsInjected = laborManagementApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /dashboard?company=&centerId=&budgetYear=&historicalYear=
    getBudgetSummary: builder.query<BudgetSummaryView, BudgetSummaryQuery>({
      query: ({ company, centerId, budgetYear, historicalYear }) => ({
        url: 'dashboard',
        params: { company, centerId, budgetYear, historicalYear },
      }),
      providesTags: (result) =>
        result
          ? [{ type: 'BudgetSummary', id: 'CURRENT' }]
          : [{ type: 'BudgetSummary', id: 'CURRENT' }],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const {
  useGetBudgetSummaryQuery,
} = budgetSummaryEndpointsInjected;
